import React from "react";
import { Link } from "react-router-dom";

/**
 * 404 – neexistující adresa (route "*"). Mimo AppShell, aby fungovala
 * i pro nepřihlášené; odkaz na /user případně projde přes login.
 */
const NotFound: React.FC = () => (
  <div className="lks-notfound">
    <i className="bi bi-signpost-split" aria-hidden="true" />
    <h1>Stránka nenalezena</h1>
    <p>Tady nic není. Adresa je špatně, nebo stránka už neexistuje.</p>
    <Link to="/user" className="btn btn-primary">
      <i className="bi bi-house me-2" aria-hidden="true" />
      Na hlavní stránku
    </Link>
  </div>
);

export default NotFound;
